import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AppComponent } from '../app.component';
import { PsModalLoadingComponent } from 'porto-seguro-guide';
import { Router } from '@angular/router';
import { ContaCreditoService, ExtratoContaCreditoService } from '../shared/services/acordo-ressarcimento/api/services';
import { ContaCredito } from '../shared/services/acordo-ressarcimento/api/models';

@Component({
  selector: 'app-conciliacao-importar-extrato',
  templateUrl: './conciliacao-importar-extrato.component.html',
  styleUrls: ['./conciliacao-importar-extrato.component.css']
})

export class ConciliacaoImportarExtratoComponent implements OnInit {
  public formExtrato: FormGroup;
  public listaContasCredito: ContaCredito[];
  public fileToUpload: File = null;

  @ViewChild('ModalConcluidoExtrato') modalConcluidoExtrato: PsModalLoadingComponent;

  constructor(
    private formBuilder: FormBuilder,
    private contaCreditoService: ContaCreditoService,
    private extratoContaCreditoService: ExtratoContaCreditoService,
    private router: Router,
    @Inject(AppComponent) public appComponent: AppComponent) { }

  public ngOnInit() {
    this.criarFormExtrato();
    this.carregarContasCredito();
  }

  private criarFormExtrato() {
    this.formExtrato = this.formBuilder.group({
      nomeConta: null,
      codigoContaCredito: null,
      agencia: null,
      numeroConta: null,
      banco: null,
      anexo: null,
    });
  }

  public carregarContasCredito() {
    this.contaCreditoService.obterContasCredito().subscribe(result => {
      this.listaContasCredito = result;
    });
  }

  public autoCompleteContaCreditoSelected($event) {
    var selected: number = $event;
    for (let i in this.listaContasCredito) {
      if (this.listaContasCredito[i].codigoContaCredito == selected) {
        this.formExtrato.controls['codigoContaCredito'].setValue(this.listaContasCredito[i].codigoContaCredito);
        this.formExtrato.controls['agencia'].setValue(this.listaContasCredito[i].numeroAgencia);
        this.formExtrato.controls['numeroConta'].setValue(this.listaContasCredito[i].numeroConta);
        this.formExtrato.controls['banco'].setValue(this.listaContasCredito[i].codigoBanco);
      }
    }
  }

  public handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  public validarTipoArquivo(): boolean {
    var ext = this.fileToUpload.name.substring(this.fileToUpload.name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'ofx') {
      return true;
    } else {
      return false;
    }
  }

  private validarFormulario(): boolean {
    var isValido = true;

    if (this.formExtrato.value['nomeConta'] == null || this.formExtrato.value['nomeConta'] == 0) {
      isValido = false;
      this.formExtrato.controls['nomeConta'].setErrors({ 'incorrect': true });
    }
    if (this.formExtrato.value['agencia'] == null) {
      isValido = false;
      this.formExtrato.controls['agencia'].setErrors({ 'incorrect': true });
    }
    if (this.formExtrato.value['numeroConta'] == null) {
      isValido = false;
      this.formExtrato.controls['numeroConta'].setErrors({ 'incorrect': true });
    }
    if (this.formExtrato.value['banco'] == null) {
      isValido = false;
      this.formExtrato.controls['banco'].setErrors({ 'incorrect': true });
    }
    if (this.formExtrato.value['anexo'] == null) {
      isValido = false;
      this.formExtrato.controls['anexo'].setErrors({ 'incorrect': true });
    }
    return isValido;
  }

  public limparDados() {
    this.formExtrato.controls['nomeConta'].setValue(null);
    this.formExtrato.controls['codigoContaCredito'].setValue(null);
    this.formExtrato.controls['agencia'].setValue(null);
    this.formExtrato.controls['numeroConta'].setValue(null);
    this.formExtrato.controls['banco'].setValue(null);
    this.formExtrato.controls['anexo'].setValue(null);
  }

  public salvarExtrato(componenteModalGravando) {
    if (!this.validarFormulario()) {
      return;
    }

    if (!this.validarTipoArquivo()) {
      this.appComponent.createAlert("O tipo de arquivo anexado não é permitido!", 'error');
      return;
    } else {

      componenteModalGravando.open("save");

      var parametros: ExtratoContaCreditoService.ImportarExtratoParams = {
        codigoContaCredito: this.formExtrato.controls['codigoContaCredito'].value,
        file: this.fileToUpload,
        nomeArquivo: this.fileToUpload.name,
      };

      this.extratoContaCreditoService.importarExtrato(parametros).subscribe(result => {
        componenteModalGravando.close();
        this.modalConcluidoExtrato.open(null);
      }, error => {
        componenteModalGravando.close();
        this.appComponent.createAlert("Erro ao efetivar cadastro!", 'error');
      });
    }
  }

  public modalConcluidoExtratoClick() {
    setTimeout(() => {
      this.router.navigate(['/conciliacao-extrato/']);
    }, 500);
  }
}
